"use client";
import {useMessages, useTranslations } from "next-intl";
import { usePathname } from "navigation";
import NavDropdown from "./NavDropdown";
import { Link } from "src/i18n/routing";

const NavLinks = () => {
  const t = useTranslations("Navbar");
  const pathname = usePathname();
  const messages = useMessages();

  const navKeys = ["services", "fleet", "cities", "solution", "clients"];

  return (
    <ul className="flex gap-8 navlink-cotainer">
      {navKeys.map((key) => {
        const route = {
          name: t(`${key}.name`),
          path: t(`${key}.path`),
          type: t(`${key}.type`),
        };
        const isActive = pathname.includes('client/') && route.path === '/clients' ? true : pathname === `${route.path}`;

        if (route.type === "dropdown") {
          const subLinks = messages.Navbar[key].subLinks;
          const subLinksKeys = Object.keys(subLinks);
          route.subLinks = subLinksKeys.map((subKey) => ({
            name: subLinks[subKey].name,
            path: subLinks[subKey].path,
          }));
        }

        return (
          <li
            key={key}
            className={`nav-link ${isActive && route.type !== "dropdown" ? "active" : ""}`}
          >
            {route.type === "dropdown" ? (
              <NavDropdown route={route} />
            ) : (
              <Link
                href={route.path}
                className={` single-link `}
              >
                {route.name}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default NavLinks;